import React from "react";
import {
  Facebook, Instagram, Linkedin, Twitter, Youtube, Globe,
} from "lucide-react";

// Custom SVG icons for platforms not in lucide-react
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"/>
  </svg>
);
const PinterestIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.888-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
  </svg>
);
const ThreadsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.7 10.9c-.1 0-.1-.1-.2-.1-.1-1.9-1.2-3-3-3.1-1 0-1.9.4-2.5 1.2l1 .7c.4-.6 1-.9 1.5-.9 1.1.1 1.7.9 1.7 2.1v.1c-.5-.1-1-.1-1.5-.1-2.2 0-3.6 1.2-3.6 2.8 0 1.5 1.3 2.5 2.8 2.5 1.3 0 2.3-.6 2.9-1.5.4.8 1.1 1.2 2 1.3v-1.2c-.4-.1-.7-.4-.9-.7-.1-.2-.2-.5-.2-.8v-3.3zM14 14.9c-.4 0-.9-.2-1.2-.5-.2-.2-.3-.5-.3-.8 0-.8.9-1.4 2.3-1.4.4 0 .8 0 1.2.1-.2 1.6-1 2.6-2 2.6zM19.4 5.7C17.7 4.5 15.4 4 12.5 4c-2.5 0-4.7.5-6.4 1.4C3.4 6.8 2 9.3 2 12.5c0 3.4 1.4 5.9 4.1 7.3C7.7 20.7 9.9 21 12.5 21c1.6 0 3-.1 4.2-.4 1.5-.4 2.9-1.2 4-2.5.9-1 1.4-2.2 1.5-3.6.1-1.1 0-2.1-.4-3.1-.5-1.2-1.4-2.2-2.6-3l-.8-.7c1.5-1 1.4-2 1-3z"/>
  </svg>
);

export const SOCIAL_PLATFORMS = {
  facebook: { label: "Facebook", Icon: Facebook, brand: "#1877F2" },
  instagram: { label: "Instagram", Icon: Instagram, brand: "#E4405F" },
  linkedin: { label: "LinkedIn", Icon: Linkedin, brand: "#0A66C2" },
  twitter: { label: "X / Twitter", Icon: Twitter, brand: "#1DA1F2" },
  youtube: { label: "YouTube", Icon: Youtube, brand: "#FF0000" },
  tiktok: { label: "TikTok", Icon: TikTokIcon, brand: "#000000" },
  pinterest: { label: "Pinterest", Icon: PinterestIcon, brand: "#E60023" },
  threads: { label: "Threads", Icon: ThreadsIcon, brand: "#000000" },
  custom: { label: "Custom", Icon: Globe, brand: "#a855f7" },
};

export const platformIcon = (platform) =>
  (SOCIAL_PLATFORMS[platform] || SOCIAL_PLATFORMS.custom).Icon;

export const platformLabel = (platform) =>
  (SOCIAL_PLATFORMS[platform] || SOCIAL_PLATFORMS.custom).label;
